/* eslint-disable no-console */
/* eslint no-underscore-dangle: ["error", { "allow": ["__typename"] }] */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// graphQL
import gql from 'graphql-tag';
// our components
import { PageInfo } from 'components/common/Paginator/PaginatorContainer';
import { Query } from 'components/common/Query';
import MultiSelect from 'components/common/MultiSelect';

/**
 * Query to fetch permissions from api
 */
export const PERMISSIONS_QUERY = gql`
  query PermissionsList(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $name: String
  ) {
    permissions(
      first: $first
      after: $after
      last: $last
      before: $before
      name: $name
    ) {
      pageInfo {
        ...PaginatorPageInfo
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
  ${PageInfo}
`;

/**
 * @class
 */
class PermissionGroupSelectContainer extends Component {
  /**
   * @description
   * Query helpful function to update query's result.
   *
   * @param {Object} previousResult - Latest Query result.
   * @param {Object} options - UpdateQuery options.
   * @returns {Object} New or Previous query's result.
   */
  updateQuery = (previousResult, options) => {
    const { pageInfo, edges: newEdges } = options.fetchMoreResult.permissions;
    if (newEdges.length !== 0) {
      return {
        permissions: {
          __typename: previousResult.permissions.__typename,
          edges: [...newEdges],
          pageInfo,
        },
      };
    }
    return previousResult;
  };

  /**
   * @description
   * Fetch more permissions according to textToFind.
   *
   * @param {string} textToFind - Text to filter permissions.
   * @param {*} fetchMore - Query callback to pagination.
   */
  handleSearchPermissions = (textToFind, fetchMore) => {
    fetchMore({
      variables: { name: textToFind, codename: textToFind },
      updateQuery: this.updateQuery,
    });
  };

  render() {
    const {
      selectedGroups,
      selectedPermissions,
      permissionUpdate,
    } = this.props;

    return (
      <Query
        query={PERMISSIONS_QUERY}
        variables={{ name: '', codename: '' }}
        fetchPolicy="cache-and-network"
        notifyOnNetworkStatusChange
      >
        {({ data, loading, fetchMore }) => {
          if (Object.keys(data).length > 0) {
            return (
              <MultiSelect
                items={data.permissions}
                selectedItems={selectedPermissions}
                extraData={{
                  byGroup: true,
                  groups: selectedGroups.map(({ id, name, permissions }) => ({
                    id,
                    name,
                    items: permissions,
                  })),
                }}
                loading={loading}
                translatePrefix="permissions"
                updateItem={permissionUpdate}
                searchItem={textToFind => {
                  this.handleSearchPermissions(textToFind, fetchMore);
                }}
                itemRender={node => node.name}
              />
            );
          }
          return null;
        }}
      </Query>
    );
  }
}

/**
 * PermissionsSelectContainer PropTypes
 * @param selectedGroups - prop permissions group pass to PermissionSelect
 * @param selectedPermissions - prop added permissions pass to PermissionSelect
 * @callback updatePermissions - callback function pass to PermissionSelect
 */

PermissionGroupSelectContainer.propTypes = {
  selectedGroups: PropTypes.instanceOf(Array),
  selectedPermissions: PropTypes.instanceOf(Array).isRequired,
  permissionUpdate: PropTypes.func.isRequired,
};

PermissionGroupSelectContainer.defaultProps = {
  selectedGroups: [],
};

export default PermissionGroupSelectContainer;
